module.exports = __webpack_public_path__ + "images/9c97527386e868b56a9e1dd047973220.jpg";